import React from 'react'
import PropTypes from 'prop-types'
import {ReactComponent as AngleLeftIcon} from '@shop/icon-fonts/optimized/angle-left-small.svg'
import * as SC from './BurgerNavigation.styled'
import {WhiteIcon} from '../Icon/Icon.styled'

const BurgerHeader = ({currentPanel, onClickPrevPanel, translations}) => {
  const {currentId, currentTitle, currentPath, parentId, parentTitle} = currentPanel
  const showPrevButton = currentId !== -1

  let upperText = parentTitle
  if (currentId === -1) {
    upperText = translations.get('shop.header.burger.navigation.shop.by')
  } else if (parentId === -1) {
    upperText = translations.get('shop.header.burger.navigation.all.products')
  }

  return (
    <SC.BurgerHeader>
      {!showPrevButton
        && <>
          <SC.BurgerTitle>{upperText}</SC.BurgerTitle>
          <SC.BurgerTitle size="big" position="bottom">
            {translations.get('shop.header.burger.navigation.category')}
          </SC.BurgerTitle>
        </>}

      {showPrevButton
        && <>
          <SC.BurgerPrevPanelButton
            onClick={() => onClickPrevPanel(currentId)}
          >
            <WhiteIcon>
              <AngleLeftIcon />
            </WhiteIcon>
            {upperText}
          </SC.BurgerPrevPanelButton>
          <SC.BurgerMainLink href={currentPath}>
            {currentTitle}
          </SC.BurgerMainLink>
        </>}
    </SC.BurgerHeader>
  )
}

BurgerHeader.propTypes = {
  currentPanel: PropTypes.shape({
    items: PropTypes.array.isRequired,
    show: PropTypes.bool.isRequired,
    currentId: PropTypes.number.isRequired,
    currentTitle: PropTypes.string,
    currentPath: PropTypes.string,
    parentId: PropTypes.number,
    parentTitle: PropTypes.string
  }).isRequired,
  onClickPrevPanel: PropTypes.func,
  translations: PropTypes.instanceOf(Map)
}

BurgerHeader.defaultProps = {
  onClickPrevPanel: () => {},
  translations: new Map()
}

export default BurgerHeader
